module.exports = __webpack_public_path__ + "img/es-frbr-en.64e2d504.svg";